export function getFlag(code: string): string {
  return ''//return require(`@/assets/flags/flag_${code}.png`)
}

export function getFlagByCode(code: string): string {
  if(code === 'de') {
    return ''//return require(`@/assets/flags/flag_switzerland.png`)
  } else if(code === 'fr') {
    return ''//return require(`@/assets/flags/flag_france.png`)
  } else if(code === 'en') {
    return ''//return require(`@/assets/flags/flag_great_britain.png`)
  } else if(code === 'it') {
    return ''//return require(`@/assets/flags/flag_italy.png`)
  } else if(code === 'pt') {
    return ''//return require(`@/assets/flags/flag_portugal.png`)
  } else {
    return ''
  }
}

export function getFlagByNumber(number: string): string {
  if(number === '1') {
    return ''//return require(`@/assets/flags/flag_switzerland.png`)
  } else if(number === '2') {
    return ''//return require(`@/assets/flags/flag_france.png`)
  } else if(number === '3') {
    return ''//return require(`@/assets/flags/flag_great_britain.png`)
  } else if(number === '4') {
    return ''//return require(`@/assets/flags/flag_italy.png`)
  } else if(number === '5') {
    return ''//return require(`@/assets/flags/flag_portugal.png`)
  } else {
    return ''
  }
}